import { useState } from "react";
import { BiHide, BiShow } from "react-icons/bi";

interface PasswordInputProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  defaultValue?: string;
  name: string;
  error?: string;
  className?: string;
  hideTitle?: boolean;
  top?: string;
  placeholder?: string;
  title?: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  onChange,
  defaultValue,
  name,
  error,
  className,
  hideTitle,
  top,
  placeholder,
  title,
}) => {
  const [biShow, setBiShow] = useState(false);

  return (
    <div className="">
      <h1 className={`${hideTitle ? "hidden" : ""} font-bold text-start mx-1`}>
        {title}
      </h1>
      <div className="relative">
        <input
          type={!biShow ? "password" : "text"}
          onChange={onChange}
          defaultValue={defaultValue}
          name={name}
          autoComplete="new-password"
          placeholder={placeholder}
          className={`border border-Secondary bg-[#F6F8F9] lg:!mt-3 mt-2 m-1 py-4 rounded-2xl ${className}`}
        />
        {biShow ? (
          <BiShow
            onClick={() => setBiShow(false)}
            size={22}
            className={`absolute left-3 top-2 mt-2 cursor-pointer text-gray-500 ${top}`}
          />
        ) : (
          <BiHide
            onClick={() => setBiShow(true)}
            size={22}
            className={`absolute left-3 top-2 mt-2 cursor-pointer text-gray-500 ${top}`}
          />
        )}
      </div>
      {error && <div className="text-red-500 font-semibold">{error}</div>}
    </div>
  );
};

export default PasswordInput;
